/* Publish by EComposer at 2026-10-01 12:02:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7p3z2o7djcb"]=  window.__ectimmers["ecom-7p3z2o7djcb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-7p3z2o7djcb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7p3z2o7djcb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c1p020o3n4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c1p020o3n4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c02938dx1fn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c02938dx1fn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pklag300i8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pklag300i8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xd3vdw20p2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xd3vdw20p2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qb7rgscxco').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qb7rgscxco', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y216tc6e4q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y216tc6e4q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u0z3t3jp7kc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u0z3t3jp7kc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hs359hkis7h"]=  window.__ectimmers["ecom-hs359hkis7h"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-hs359hkis7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hs359hkis7h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}